// extracted by mini-css-extract-plugin
module.exports = {"chestBalance":"_034075b"};